import { Box } from '@cdl/heartbeat-react';
import * as React from 'react';
import { PropsWithChildren } from 'react';

interface Props {}

interface State {
  hasError: boolean;
}

export class ErrorBoundary extends React.Component<
  PropsWithChildren<Props>,
  State
> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return <Box m='m'>The app has crashed. Try reloading the page</Box>;
    }
    return this.props.children;
  }
}
